<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-BI">To Arabic and English, the two languages of my pen. Arabic moves on the page from right to left. English moves from left to right. They meet in my heart, forming a bridge of peace between East and West.</span></p>
<p class="DED"><span class="ePub-BI">To my family members, the Barakats.</span></p>
<p class="DED"><span class="ePub-BI">To my people, the Palestinians.</span></p>
<p class="DED"><span class="ePub-BI">To our Qur’anic and Biblical cousins, the Jews.</span></p>
<p class="DED"><span class="ePub-BI">To everyone who helps create more kindness among the peoples of the world and more healing for the family of humanity.</span></p>
<p class="DED"><span class="ePub-BI">And to readers everywhere.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4c1a6bfc